import { Component, OnInit, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import { IntegrationComponent } from './../integration/integration.component';

import { IntegrationModel } from 'app/shared/models/integration.model';

import { IntegrationService } from './../integration.service';

@Component({
    selector: 'app-integration-list',
    templateUrl: './integration-list.component.html'
})

/**
 * Component to display the integration list.
 */
export class IntegrationListComponent implements OnInit {
    dialogRef: MdDialogRef<any>;
    integrations: IntegrationModel[];
    selectedIntegration: IntegrationModel;

    constructor(
        private dialog: MdDialog,
        private viewContainerRef: ViewContainerRef,
        private integrationService: IntegrationService,
        private snackBarService: SnackBarService,
        private trackingService: TrackingService
    ) { }

    // Model value for list.
    @Input() status: String;

    ngOnInit() {
        this.updateIntegrationsList();
    }

    editIntegration(selectedIntegration: IntegrationModel): void {
        const action = 'Edit';
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(IntegrationComponent, config);
        this.dialogRef.componentInstance.selectedIntegration = selectedIntegration;
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(response => {
            this.dialogRef = null;
            if (response) {
                this.updateIntegrationsList();
            }
            this.selectedIntegration = null;
        });
    }

    deleteIntegration(integration: IntegrationModel) {
        if (confirm(MessageService.DELETE_INTEGRATION_ALERT)) {
            this.integrationService.deleteIntegration(integration.id)
                .subscribe(response => {
                    if (response.flagResult) {
                        this.integrations.splice(this.integrations.indexOf(integration), 1);
                    }
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.INTEGRATIONS,
                        TrackingConstants.DELETE_INTEGRATION,
                        TrackingConstants.SUCCESS, 1);
                    this.callSnackBarService(response,
                        MessageService.DELETE_INTEGRATION_SUCCESS, MessageService.DELETE_INTEGRATION_FAILURE);
                },
                err => {
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.INTEGRATIONS,
                        TrackingConstants.DELETE_INTEGRATION,
                        TrackingConstants.FAILURE, 0);
                    this.callSnackBarService(err,
                        MessageService.DELETE_INTEGRATION_SUCCESS,
                        MessageService.DELETE_INTEGRATION_FAILURE);
                });
        }
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }

    updateIntegrationsList() {
        this.integrationService.getIntegrationsList()
            .subscribe(integrations => { this.integrations = integrations; });
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/integrations/integrationlist/integration-list.component.ts